import { useTranslation } from 'react-i18next'

import { Link } from 'features/i18n/router'
import UserFollowRequestList from 'features/User/components/UserFollowRequestList'

const FollowRequestModal = (props) => {
  const { t } = useTranslation()
  return (
    <div className="Modal__wrapper">
      <div className="Modal__header">
        <Link className="Modal__header__close" to={props.location.pathname} />
        <h2 className="Modal__header__h2">{t('follow_request_modal.title')}</h2>
      </div>
      <div className="Modal__body">
        <UserFollowRequestList />
      </div>
    </div>
  )
}

export default FollowRequestModal
